type JSONValue = string | number | boolean | JSONObject | JSONArray;
interface JSONObject {
  [x: string]: JSONValue;
}
type JSONArray = Array<JSONValue>;

export const BOOKING_ENQUIRY_MESSAGE_LOCAL_STORAGE_KEY = 'bookingEnquiryMessage';
export const TEMP_USER_MOBILE_LOCAL_STORAGE_KEY = 'bookingEnquiryPhoneNumber';

export const getLocalStorage = (key: string, initialValue: JSONValue): JSONValue => {
  if (typeof window === 'undefined') {
    return initialValue;
  }

  return window?.localStorage.getItem(key) ?? initialValue;
};

export const setLocalStorage = (key: string, value: JSONValue, stringify?: boolean): void => {
  if (!stringify) {
    window?.localStorage.setItem(key, value as string);

    return;
  }

  window?.localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalStorage = (key: string): void => {
  window?.localStorage.removeItem(key);
};
